import React from 'react';
import ExpressSignUp from '../components/profile/ExpressSignUp';

const ExpressSignUpPage: React.FC = () => {
  return <ExpressSignUp />;
};

export default ExpressSignUpPage;
